export default __webpack_public_path__ + "img/shape-oval.d0297ed1.svg";